import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import sharedCalendarImage from 'img/family-content/empty-new-block-family-calendar.png';
import sharedCalendarImageDark from 'img/family-content/empty-new-block-family-calendar-dark.png';
import { xray } from 'lib/xray';
import React from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { useFamilyCalendarClick } from 'reactApp/sections/FamilyPage/hooks/useFamilyCalendarClick';
import baseStyles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

import styles from './FamilyContentNewEmptyCards.css';

interface SharedCalendarProps {
    paySource: string;
}

export const SharedCalendar: React.FC<SharedCalendarProps> = ({ paySource }) => {
    const onCalendarButtonClick = useFamilyCalendarClick({ paySource });

    const onClick = (): void => {
        xray.send('empty-family-calendar', { p: 'cloud' });
        onCalendarButtonClick?.();
    };

    return (
        <div id="family-card-calendar" className={`${baseStyles.card}`} onClick={onClick} data-qa-id="family-shared-calendar">
            <Title level="2" data-qa-id="family-shared-calendar-title">
                Планируйте&nbsp;общие&nbsp;дела
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-calendar-content">
                Добавляйте в него события — <br />
                они появятся у всех в подписке
            </Text>
            <Spacing size={20} style={{ pointerEvents: 'none' }} />
            <Button
                mode="primary"
                appearance="accent-invariable"
                size="l"
                className={styles.button}
                data-qa-id="family-shared-calendar-button"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                Запланировать
            </Button>
            <img
                src={isDarkTheme ? sharedCalendarImageDark : sharedCalendarImage}
                alt="Общие дела"
                className={styles.image}
                data-qa-id="family-shared-calendar-image"
            />
        </div>
    );
};
